module.exports = __webpack_public_path__ + "static/media/netlify-ar21.626728b1.svg";